/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 6/28/2016
 * Time: 9:52 AM
 */
import React from 'react';
import { FormattedMessage, intlShape } from 'react-intl';
import FormError from './FormError';
import {Input, Select, SelectPro} from 'react-form-controlled';

const defaultErrorMessage = {
  id: 'input.error',
  description: 'A default message to display when no error message is provided',
  defaultMessage: 'Input field has an error.'
};

function textInput(props) {
  const { type, name, hasError = false, errorMessage = defaultErrorMessage, labelMessage, placeholderMessage, formatMessage, disabled = false } = props;

  const placeholder = placeholderMessage || labelMessage;

  const errorNode = hasError ? <FormError message={errorMessage}/> : null;

  return <div key={name} className={`form-group ${name}`}>
    <label htmlFor={name} className="form-label">
      <FormattedMessage {...labelMessage} />
    </label>
    <Input type={type}
           debounce={0}
           className="form-control"
           name={name}
           placeholder={formatMessage(placeholder)}
           disabled={disabled}
    />
    {errorNode}
  </div>;
}

function checkboxInput(props) {
  const { name, labelMessage } = props;

  return <div key={name} className={`form-group checkbox ${name}`}>
    <label htmlFor={name} className="form-label">
      <FormattedMessage {...labelMessage} /> <Input type="checkbox" name={name} id={name}/>
    </label>
  </div>;
}

function selectInput(props) {
  const { name, hasError = false, options = {}, errorMessage = defaultErrorMessage, placeholderMessage, labelMessage, formatMessage, disabled = false } = props;

  const errorNode = hasError ? <FormError message={errorMessage}/> : null;

  const placeholder = placeholderMessage || labelMessage;

  return <div key={name} className={`form-group ${name}`}>
    <label htmlFor={name} className="form-label">
      <FormattedMessage {...labelMessage} />
    </label>
    <Select className="form-control"
            name={name}
            disabled={disabled}
            options={options}
            placeholder={formatMessage(placeholder)}
    />
    {errorNode}
  </div>;
}

export {
  textInput,
  checkboxInput,
  selectInput
};



/** WEBPACK FOOTER **
 ** ./src/main/js/common/util/FormInput.js
 **/